import React, {memo} from 'react';
import { Group, Stage, FastLayer, Rect, Line} from 'react-konva';

export default memo(({coloredWaveformPoints}) => {
    return (
        <FastLayer>
          {coloredWaveformPoints.map( 
                    (pt, i) => 
                     <Rect
                       key={"point-" + i}
                       x={pt.x}
                       y={pt.y}
                       width={pt.width}
                       height={pt.height}
                       fill={'rgb(' + pt.rgb[0] + ',' + pt.rgb[1] + ',' + pt.rgb[2] + ')'}/>)
          }
        </FastLayer>
    );
});
